import BaseAnalytics  from './BaseAnalytics';

interface IEcommerceItem {
    id: number,
    name: string,
    category: string,
    list: string,
    position: number,
    variant?: string,
    price?: number,
}

interface IEcommerceDetail {
    detail: {
        products: IEcommerceItem[],
    },
}

interface IEcommercePurchase {
    purchase: {
        actionField: {
            id: string,
        },
        products: IEcommerceItem[],
    },
}

interface IEcommerceImpressions {
    currencyCode: string,
    impressions: IEcommerceItem[],
}

class EcommerceAnalytics extends BaseAnalytics {

    constructor(category = 'ecommerce') {
        super();
        this.category = category;
    }

    sendDetails(products: IEcommerceItem[]) {
        this.sendEcommerce<IEcommerceDetail>({
            event: 'UAevent',
            category: this.category,
            action: 'detail',
            ecommerce: {
                detail: {
                    products,
                },
            },
        });
    }

    sendPurchase(products: IEcommerceItem[], transactionId: string) {
        this.sendEcommerce<IEcommercePurchase>({
            event: 'UAevent',
            category: this.category,
            action: 'purchase',
            ecommerce: {
                purchase: {
                    actionField: {
                        id: transactionId,
                    },
                    products,
                },
            },
        });
    }

    sendImpressions(impressions: IEcommerceItem[], currencyCode = 'RUB') {
        this.sendEcommerce<IEcommerceImpressions>({
            event: 'UAevent',
            category: this.category,
            action: 'impressions',
            ecommerce: {
                currencyCode,
                impressions,
            },
        });
    }
}


export default EcommerceAnalytics;

